<template>
  <div>
    <v-chip
      :color="chipColor"
      :large="buttonSize === 'large'"
      :small="buttonSize === 'small'"
      :text-color="chipTextColor"
      label
    >
      <v-avatar>
        <v-icon
          class="ml-0 mr-2"
          small
        >{{ chipIcon }}</v-icon>
      </v-avatar>
      {{ $t(chipLabel) }}
    </v-chip>
  </div>
</template>

<script>
import ReceiptStatuses from '@/utils/statuses/receipt'
import PaymentStatuses from '@/utils/statuses/payment'
import InventoryCountStatuses from '@/utils/statuses/inventory-count'

export default {
  name: 'StatusChip',

  props: {
    statusCode: {
      type: Number,
      required: true
    },
    statusType: {
      type: String,
      required: true
    },
    buttonSize: {
      type: String,
      required: false,
      default: 'small'
    }
  },

  data: () => ({
    chipColor: 'primary',
    chipTextColor: 'white',
    chipIcon: null,
    chipLabel: null
  }),

  watch: {
    statusCode: {
      immediate: true,
      handler () {
        this.updateChip()
      }
    },
    statusType: {
      immediate: true,
      handler () {
        this.updateChip()
      }
    }
  },

  methods: {
    updateChip () {
      let Statuses = null
      switch (this.statusType) {
        case 'receipt': Statuses = ReceiptStatuses
          break
        case 'payment': Statuses = PaymentStatuses
          break
        case 'inventory-count': Statuses = InventoryCountStatuses
          break
      }

      this.chipColor = Statuses.find((x) => x.code === this.statusCode).color
      this.chipIcon = Statuses.find((x) => x.code === this.statusCode).icon
      this.chipLabel = Statuses.find((x) => x.code === this.statusCode).label
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chips/StatusChip.vue